import { render, staticRenderFns } from "./DevExperience.vue?vue&type=template&id=6ae7c44a&scoped=true&"
import script from "./DevExperience.vue?vue&type=script&lang=ts&"
export * from "./DevExperience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7c44a",
  null
  
)

export default component.exports